import { render, staticRenderFns } from "./JourneyFormStandardGoodsTable.vue?vue&type=template&id=3922450f&scoped=true&"
import script from "./JourneyFormStandardGoodsTable.vue?vue&type=script&lang=js&"
export * from "./JourneyFormStandardGoodsTable.vue?vue&type=script&lang=js&"
import style0 from "./JourneyFormStandardGoodsTable.vue?vue&type=style&index=0&id=3922450f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3922450f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
